module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-layout"
  }, [_c('ul', {
    staticClass: "navigation"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.routes), function(route) {
    return _c('li', [_c('v-link', {
      attrs: {
        "href": route.path
      }
    }, [_vm._v(_vm._s(route.name))])], 1)
  })], 2), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo32.png")
    }
  }), _vm._v("Destiny Loot History")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d25bd2f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d25bd2f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Main.vue
// module id = 56
// module chunks = 0 1